import { ReactElement } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
  spinning?: boolean;
}

export const LoadingSpinnerIcon = ({
  className = '',
  size = 20,
  color = 'text-blue-500',
  spinning = false,
}: Props): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`${spinning ? 'animate-spin' : ''} ${color} ${className}`}
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
    />
  </svg>
);
